module.exports = __webpack_public_path__ + "static/ABA_2020-Finalist_Customer Service of the Year-648addf7d11ae6e4c35f077dfdec0028.png";